/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Location_Share_LabelInputs */

const en_ticket_location_share_label = /** @type {(inputs: Ticket_Location_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share live location`)
};

const ja_ticket_location_share_label = /** @type {(inputs: Ticket_Location_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在地を共有`)
};

const fr_ticket_location_share_label = /** @type {(inputs: Ticket_Location_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager la position en direct`)
};

const de_ticket_location_share_label = /** @type {(inputs: Ticket_Location_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Standort teilen`)
};

/**
* | output |
* | --- |
* | "Share live location" |
*
* @param {Ticket_Location_Share_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_location_share_label = /** @type {((inputs?: Ticket_Location_Share_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Location_Share_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_location_share_label(inputs)
	if (locale === "ja") return ja_ticket_location_share_label(inputs)
	if (locale === "fr") return fr_ticket_location_share_label(inputs)
	return de_ticket_location_share_label(inputs)
});